"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getNumToNearestHundred_1 = __importDefault(require("./getNumToNearestHundred"));
var getSalaryStringWithOutBreak = function (input) {
    var salaryToNearestHun = (0, getNumToNearestHundred_1.default)(input);
    var salaryThous = (salaryToNearestHun / 1000) % 1 === 0
        ? (salaryToNearestHun / 1000).toFixed(0)
        : (salaryToNearestHun / 1000).toFixed(1);
    return "$".concat(salaryThous, "k careers");
};
exports.default = getSalaryStringWithOutBreak;
